var map = {
	"./file/acc.svg": "7f8f",
	"./file/ae.svg": "f359",
	"./file/ai.svg": "13df",
	"./file/album.svg": "f214",
	"./file/an.svg": "a965",
	"./file/article.svg": "e215",
	"./file/audio.svg": "db69",
	"./file/avi.svg": "9b2d",
	"./file/bmp.svg": "0989",
	"./file/csv.svg": "3ccf",
	"./file/dat.svg": "da19",
	"./file/default.svg": "98ac",
	"./file/dgn.svg": "ca05",
	"./file/doc.svg": "770a",
	"./file/doch.svg": "a212",
	"./file/docm.svg": "8f0a",
	"./file/docx.svg": "2dd9",
	"./file/doth.svg": "6912",
	"./file/dw.svg": "df21",
	"./file/dwfx.svg": "bbaa",
	"./file/dwg.svg": "1493",
	"./file/dx.svg": "5d89",
	"./file/dxf.svg": "43b9",
	"./file/eml.svg": "2186",
	"./file/eps.svg": "714e",
	"./file/f4a.svg": "c761",
	"./file/f4v.svg": "2fbb",
	"./file/flv.svg": "56ec",
	"./file/fs.svg": "bdcf",
	"./file/fv4.svg": "3793",
	"./file/gif.svg": "f04a",
	"./file/guestbook.svg": "81c8",
	"./file/html.svg": "f71d",
	"./file/iframe.svg": "ee72",
	"./file/ind.svg": "8a91",
	"./file/jpeg.svg": "fd33",
	"./file/jpg.svg": "b079",
	"./file/jpp.svg": "6243",
	"./file/log.svg": "5c8f",
	"./file/lr.svg": "6fa2",
	"./file/m4a.svg": "1464",
	"./file/m4v.svg": "a0ff",
	"./file/mbox.svg": "5d9b",
	"./file/mdb.svg": "a475",
	"./file/midi.svg": "6cbf",
	"./file/mkv.svg": "9e49",
	"./file/mov.svg": "a6d3",
	"./file/mp3.svg": "39e8",
	"./file/mp4.svg": "14b1",
	"./file/mpeg.svg": "4486",
	"./file/mpg.svg": "aca8",
	"./file/mpp.svg": "db3e",
	"./file/mpt.svg": "6f0e",
	"./file/mpw.svg": "48cc",
	"./file/mpx.svg": "0095",
	"./file/ms.svg": "3862",
	"./file/ods.svg": "f2b2",
	"./file/oga.svg": "2b04",
	"./file/ogg.svg": "baba",
	"./file/ogv.svg": "2878",
	"./file/one.svg": "2723",
	"./file/ost.svg": "289d",
	"./file/pdf.svg": "df2d",
	"./file/php.svg": "23b5",
	"./file/png.svg": "937f",
	"./file/pot.svg": "e3ad",
	"./file/poth.svg": "63e6",
	"./file/potm.svg": "fb2b",
	"./file/potx.svg": "a13d",
	"./file/pps.svg": "113e",
	"./file/ppsx.svg": "dbfa",
	"./file/ppt.svg": "969b",
	"./file/ppth.svg": "0b1b",
	"./file/pptm.svg": "8a9f",
	"./file/pptx.svg": "9336",
	"./file/prem.svg": "cb37",
	"./file/ps.svg": "a16d",
	"./file/psd.svg": "a4b7",
	"./file/pst.svg": "2b8b",
	"./file/pub.svg": "ac82",
	"./file/pubh.svg": "22c6",
	"./file/pubm.svg": "17e5",
	"./file/pwz.svg": "f3d3",
	"./file/read.svg": "16e0",
	"./file/rp.svg": "924c",
	"./file/rtf.svg": "10ea",
	"./file/sql.svg": "1074",
	"./file/svg.svg": "3013",
	"./file/swf.svg": "7207",
	"./file/tif.svg": "5514",
	"./file/tiff.svg": "5e36",
	"./file/txt.svg": "54f4",
	"./file/url.svg": "61d3",
	"./file/vcf.svg": "14a8",
	"./file/vdx.svg": "d6d5",
	"./file/video.svg": "16cb",
	"./file/vob.svg": "5b76",
	"./file/vsd.svg": "ae2a",
	"./file/vss.svg": "86ac",
	"./file/vst.svg": "7cab",
	"./file/vsx.svg": "fcd1",
	"./file/vtx.svg": "b174",
	"./file/wav.svg": "8368",
	"./file/wdp.svg": "68eb",
	"./file/webm.svg": "3f11",
	"./file/wm.svg": "6cd6",
	"./file/wma.svg": "57e9",
	"./file/xd.svg": "bc97",
	"./file/xls.svg": "cd0f",
	"./file/xlsm.svg": "51bc",
	"./file/xlsx.svg": "9ecd",
	"./file/xml.svg": "f8b4",
	"./file/zip.svg": "5f88"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6f32";